import { isFunction, __DEV__ } from "./assertion";
export function runIfFn(valueOrFn) {
  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  return isFunction(valueOrFn) ? valueOrFn.apply(void 0, args) : valueOrFn;
}
export function callAllHandlers() {
  for (var _len2 = arguments.length, fns = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    fns[_key2] = arguments[_key2];
  }

  return function func(event) {
    fns.some(function (fn) {
      fn == null ? void 0 : fn(event);
      return event == null ? void 0 : event.defaultPrevented;
    });
  };
}
export function callAll() {
  for (var _len3 = arguments.length, fns = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
    fns[_key3] = arguments[_key3];
  }

  return function mergedFn(arg) {
    fns.forEach(function (fn) {
      fn == null ? void 0 : fn(arg);
    });
  };
}
export function once(fn) {
  var result;
  return function func() {
    if (fn) {
      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
        args[_key4] = arguments[_key4];
      }

      result = fn.apply(this, args);
      fn = null;
    }

    return result;
  };
}
export var noop = function noop() {};
export var warn = once(function (options) {
  var condition = options.condition,
      message = options.message;

  if (condition && __DEV__) {
    console.warn(message);
  }
});
export var error = once(function (options) {
  var condition = options.condition,
      message = options.message;

  if (condition && __DEV__) {
    console.error(message);
  }
});